import { ROUTES as defaultRoutes } from '../../../default/routes.ts';
import { ROUTES as ukRoutes } from './routes.ts';

const ROUTES = {
  ...defaultRoutes,
  ...ukRoutes,
};

const NON_CACHEABLE_ROUTES_REGEX = [
  `^${ROUTES.MY_ACCOUNT.ROOT}.*`,
  `^${ROUTES.TIME_OFF}.*`,
  `^${ROUTES.REGISTER}.*`,
  `^${ROUTES.CASINO.FAVOURITES}`,
  '^/ob',
  '^/offer-choice/',
  '^/a/',
  `^${ROUTES.LOTTO.PURCHASES}`,
  '^/lotteries/.*/results-winning-numbers',
  '^/lotteries/keno247', //TODO: WEBD-1969 - this line to be removed
  `^${ROUTES.LIVE_CASINO.FAVOURITES}`,
];

export { NON_CACHEABLE_ROUTES_REGEX };
